var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 position-relative"},[_c('div',{staticStyle:{"width":"90%","height":"90%"},attrs:{"id":"relationView"}})])}]

export { render, staticRenderFns }